module.exports = __webpack_public_path__ + "assets/img/tx102ns.afac1c77.jpg";